/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Submit venue transfer request.
 */
export interface VenueTransferRequest {
  /**
   * Active route to transfer by
   */
  routeId: number;
  /**
   * Amount in route asset
   */
  amount: number;
}
